<template>
    <div class="most-popular__info">
        <img v-if="props.channelLogo" class="most-popular__info-logo" :src="props.channelLogo" :alt="props.channelName" loading="lazy">
        <div class="most-popular__info-title">{{ props.title }}</div>
        <div class="most-popular__wrap-info-btn">
            <button 
                id="btnSlider"
                type="button" 
                class="most-popular__info-btn"
                :class="{'most-popular__info-btn_black': isFizzTV}"
                @click="onItemSelected"
            >
                {{ btnName }}
            </button>
            <common-icon class="most-popular__image-lock" :icon-name="'IconLock'" />
        </div>
    </div>
</template>

<script lang="ts" setup >
    import { isFizzTV } from "@ca.vmedia.tv/domains";
    import { useI18n } from "vue-i18n";
    import { Strings } from "@/locales/types/enums";
    import type { PropType } from "#imports";

    const emit = defineEmits(['on-item-selected']);

    const props = defineProps({
        title: {
            type: String,
            required: true
        },
        channelName: {
            type: String,
            required: true
        },
        channelLogo: {
            type: [String, null, undefined] as PropType<string | null | undefined>,
            required: true
        },
    });
    const { t } = useI18n();
    const btnName: string = t(Strings.VOD_BTN_WATCHING_NAME).toString();

    const onItemSelected = () => {
        emit('on-item-selected');
    };

</script>
